import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/deducciones-subtipos-de-nominas';

/**
 * GET Deducciones Subtipos de Nominas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDeduccionesSubtiposDeNominas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Deduccion Subtipo de Nomina
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getDeduccionSubtipoDeNomina = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Deduccion Subtipo de Nomina
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDeduccionSubtipoDeNomina = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Deduccion Subtipo de Nomina
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDeduccionSubtipoDeNomina = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Deduccion Subtipo de Nomina
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteDeduccionSubtipoDeNomina = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
